import React, { useState, useEffect } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import api from '../utils/api';
import { flagUrl } from '../utils/currencies';

export const FiatRates = () => {
  const { t } = useLanguage();
  const f = t.fiatlive || {};
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get('/fiat/rates').then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return null;
  const pairs = [
    { label: 'EUR/USD', value: data.pairs.EUR_USD, flags: ['EUR', 'USD'] },
    { label: 'USD/RUB', value: data.pairs.USD_RUB, flags: ['USD', 'RUB'] },
    { label: 'EUR/RUB', value: data.pairs.EUR_RUB, flags: ['EUR', 'RUB'] },
  ];
  const flag = (c) => ({ EUR: 'eu', USD: 'us', RUB: 'ru' }[c]);

  return (
    <div className="flex items-center flex-wrap gap-3" data-testid="fiat-rates-bar">
      <span className="text-[10px] uppercase font-bold text-gray-400 tracking-wider">{f.title || 'Taux fiat en direct'}</span>
      {pairs.map((pr) => pr.value && (
        <div key={pr.label} className="flex items-center space-x-2 bg-white rounded-full pl-2 pr-4 py-1.5 shadow-sm border border-gray-100" data-testid={`fiat-pair-${pr.label.replace('/', '-')}`}>
          <span className="flex -space-x-1.5">
            {pr.flags.map((c) => (
              <img key={c} src={flagUrl(flag(c))} alt={c} className="w-4 h-4 rounded-full border border-white object-cover" />
            ))}
          </span>
          <span className="text-xs font-bold text-gray-500">{pr.label}</span>
          <span className="text-xs font-extrabold text-gray-900 font-mono-data">{pr.value.toLocaleString('fr-FR')}</span>
        </div>
      ))}
    </div>
  );
};

export default FiatRates;
